/**
 * Attachment handling for the New Work Item modal.
 *
 * Screenshots arrive by paste: the clipboard names every pasted image "image.png",
 * so they are renamed with a running number before queueing — DevOps would otherwise
 * show three identical names with no way to tell them apart.
 */

/** Mirrors MAX_ATTACHMENT_BYTES in backend/app/api/api_v1/endpoints/devops_board.py. */
export const MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024;

export function attachmentTooLarge(file: File): boolean {
  return file.size > MAX_ATTACHMENT_BYTES;
}

/** "screenshot-3.jpeg" for the third pasted image of type image/jpeg. */
export function pastedFileName(n: number, mimeType: string): string {
  const subtype = /^image\/([a-z0-9]+)/i.exec(mimeType)?.[1];
  return `screenshot-${n}.${(subtype || 'png').toLowerCase()}`;
}

/**
 * The image files in a paste event, renamed sequentially starting at `startAt`.
 * Non-image clipboard content (the text that often rides along) is ignored.
 */
export function imageFilesFromClipboard(
  items: ArrayLike<DataTransferItem>,
  startAt: number,
): File[] {
  const files: File[] = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.kind !== 'file' || !item.type.startsWith('image/')) continue;
    const file = item.getAsFile();
    if (!file) continue;
    files.push(
      new File([file], pastedFileName(startAt + files.length, file.type), {
        type: file.type,
      }),
    );
  }
  return files;
}
